<template>
  <div class="search-result-tag">
    {{title}}
    <!-- <img
      class="pl-img"
      v-if="!!showComment"
      @click="showAlert"
      src="../assets/img/pinglun.png"
    /> -->
    <div class="pl-img"
      v-if="!!showComment"
      @click="showAlert">
      <img src="../assets/img/pl.png" alt="">
      <span>我要评论</span>
    </div>
  </div>
</template>

<script>
export default {
  props: ["title", "showComment"],
  methods: {
    showAlert() {
      // this.$alert(
      //   `<img style="width:180px;height:180px;display:block;margin:0 auto;" src="data:image/png;base64,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"/>`,
      //   "扫码下载农极客APP",
      //   {
      //     dangerouslyUseHTMLString: true,
      //   }
      // );
      this.$emit('addComment')
    },
  },
};
</script>

<style lang="scss" scoped>
.search-result-tag {
  width: 100%;
  font-size: 18px;
  color: #333;
  height: 32px;
  line-height: 32px;
  border-bottom: 1px solid #65b825;
  border-left: 5px solid #65b825;
  padding-left: 8px;
  margin-top: 16px;
  margin-bottom: 16px;
  text-align: left;
  position: relative;
  .pl-img {
    position: absolute;
    width: 102px;
    height: 30px;
    right: 0;
    bottom: 0;
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
    color:#fff;
    background: #65B825;
    padding: 0 12px;
    img{
      width: 14px;
      height: 14px;
    }
  }
}
</style>
